// Static presentation data and formatting helpers.
// The catalogue comes from the API; what stays here is the material that is
// not per-book content: category labels, hero artwork and time formatting.

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1625786682948-2168238883d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBoZWFkcGhvbmVzfGVufDB8fHx8MTc4NjgxNzY2Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1519791883288-dc8bd696e667?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxyZWFkaW5nJTIwbmlnaHR8ZW58MHx8fHwxNzg2ODE3NjY2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1598024055266-e772a5f8c128?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxyZWFkaW5nJTIwbmlnaHR8ZW58MHx8fHwxNzg2ODE3NjY2fDA&ixlib=rb-4.1.0&q=85",
];

export const CATEGORIES = [
  { id: "fiction", en: "Fiction" },
  { id: "thriller", en: "Mystery, Thriller & Suspense" },
  { id: "romance", en: "Romance" },
  { id: "fantasy", en: "Science Fiction & Fantasy" },
  { id: "children", en: "Children's Audiobooks" },
  { id: "teen", en: "Teen & Young Adult" },
  { id: "selfhelp", en: "Health & Personal Development" },
  { id: "biography", en: "Biographies & Memoirs" },
  { id: "business", en: "Business & Careers" },
  { id: "money", en: "Money & Finance" },
  { id: "history", en: "History" },
  { id: "comedy", en: "Comedy & Humour" },
  { id: "crime", en: "Crime & Detective" },
  { id: "nonfiction", en: "Non-fiction" },
  { id: "science", en: "Science & Technology" },
  { id: "religion", en: "Religion & Spirituality" },
  { id: "politics", en: "Politics & Social Sciences" },
  { id: "arts", en: "Arts & Entertainment" },
  { id: "sports", en: "Sports & Outdoors" },
  { id: "travel", en: "Travel & Tourism" },
  { id: "relationships", en: "Relationships & Parenting" },
  { id: "education", en: "Education & Learning" },
  { id: "language", en: "Language Learning" },
  { id: "reference", en: "Reference" },
  { id: "classics", en: "Literature & Classics" },
  { id: "cooking", en: "Cooking, Food & Wine" },
  { id: "homegarden", en: "Home & Garden" },
  { id: "nature", en: "Nature & Ecology" },
  { id: "tech", en: "Computers & Technology" },
  { id: "lgbtq", en: "LGBTQ+" },
];

export const HERO_SLIDES = [
  {
    bookId: "book-3",
    image: HERO_IMAGES[0],
    tagline_en: "Listen anywhere. Escape everywhere.",
  },
  {
    bookId: "book-2",
    image: HERO_IMAGES[1],
    tagline_en: "Stories that stay with you.",
  },
  {
    bookId: "book-5",
    image: HERO_IMAGES[2],
    tagline_en: "Your next obsession is waiting.",
  },
];

export function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m} min`;
}

/**
 * Clock time for a position or a chapter length.
 *
 * Chapters here run to an hour and beyond, and without the hours field a
 * 1h20m chapter read as "80:00" everywhere it appeared — the chapter list, the
 * CMS and the player's own counter.
 */
export function formatTime(seconds) {
  if (!seconds || isNaN(seconds) || seconds < 0) return "0:00";
  const total = Math.floor(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}
